import React from 'react';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import Hero from '../components/sections/Hero';
import Scorecard from '../components/sections/Scorecard';
import WealthCalculator from '../components/sections/WealthCalculator';
import Resources from '../components/sections/Resources';
import Events from '../components/sections/Events';

const Home = () => {
  return (
    <div className="min-h-screen font-sans text-slate-900">
      <Header />
      <main>
        <Hero />
        <section id="about" className="py-20 bg-white">
          <div className="container mx-auto px-4 text-center">
            <img
              src="https://media.publit.io/file/profile-photos/Jenny-photo.jpg"
              alt="Jenny Rodriguez-Minchala"
              className="w-32 h-32 rounded-full mx-auto mb-6 object-cover shadow-lg"
            />
            <h2 className="text-3xl font-bold mb-2">Jenny Rodriguez-Minchala</h2>
            <p className="text-pink-600 font-bold mb-6">Founder, Mujeres y Riquezas</p>
            <p className="max-w-2xl mx-auto text-gray-600 leading-relaxed">
              "Mi misión es simple: poner más dinero en manos de mujeres con buen corazón. 
              Cuando una mujer construye riqueza, toda su comunidad prospera."
            </p>
          </div>
        </section>
        <Scorecard />
        <WealthCalculator />
        <Resources />
        <Events />
      </main>
      <Footer />
    </div>
  );
};

export default Home;